import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import * as firebase from "firebase/app";
import { AngularFireAuth } from "@angular/fire/auth";
import {
  AngularFirestore,
  AngularFirestoreDocument,
} from "@angular/fire/firestore";
import { of } from "rxjs";
import "rxjs/add/operator/switchMap";
import { Users } from "../../models/user.model";
import { switchMap } from "rxjs/operators";
import { first } from "rxjs/operators";
import { Observable } from "rxjs/Observable";
import { NotifyService } from "../../../shared/services/auth/notify.service";
import { FirebaseDataShareService } from "../firebase-data-share.service";

@Injectable()
export class FirebaseAuthService {
  user: Observable<Users | null>;
  authState: any = null;
  data: any;

  constructor(
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private router: Router, // private notify: NotifyService
    private notify: NotifyService,
    private datas: FirebaseDataShareService
  ) {
    /// Get auth Data, then firestore user document // null
    this.user = this.afAuth.authState.pipe(
      switchMap((user) => {
        if (user) {
          return this.afs.doc<Users>(`users/${user.uid}`).valueChanges();
        } else {
          return of(null);
        }
      })
      // tap(user => localStorage.setItem('user', JSON.stringify(user))),
      // startWith(JSON.parse(localStorage.getItem('user')))
    );
  }

  facebookLogin() {
    const provider = new firebase.auth.FacebookAuthProvider();
    return this.oAuthLogin(provider);
  }

  googleLogin() {
    const provider = new firebase.auth.GoogleAuthProvider();
    return this.oAuthLogin(provider);
  }

  private oAuthLogin(provider) {
    return this.afAuth.auth
      .signInWithPopup(provider)
      .then((credential) => {
        this.updateUserData(credential.user);
        // take uid to share
        this.datas.changeUser(credential.user.uid);
      })
      .catch((error) => this.handleError(error));
  }
  // user creation on database
  private updateUserData(user) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(
      `users/${user.uid}`
    );

    // save user data on firestore
    const data = {
      uid: user.uid,
      firstName: "",
      lastName: "",
      checked: true,
      signUpdate: new Date(),
      email: user.email || "",
      displayName: user.displayName,
      country: "",
      photoURL: user.photoURL || "./assets/images/anon.jpg",
      roles: {
        members: true,
        admin: false,
      },
      // locality: {
      //   name: user.locality.name
      // },
      memberType: user.memberType || "non-member",
    };

    return userRef.set(data, { merge: true });
  }

  updateUser(user: Users, data: any) {
    return this.afs.doc(`users/${user.uid}`).set(data, { merge: true });
  }

  emailSignUp(email: string, password: string) {
    return this.afAuth.auth
      .createUserWithEmailAndPassword(email, password)
      .then((credential) => {
        this.notify.update("Welcome new user!", "success");
        return this.updateUserData(credential.user); // if using firestore
      })
      .catch((error) => this.handleError(error));
  }

  emailLogin(email: string, password: string) {
    return this.afAuth.auth
      .signInWithEmailAndPassword(email, password)
      .then((credential) => {
        this.notify.update("Welcome back!", "success");
        return this.updateUserData(credential.user);
      })
      .catch((error) => this.handleError(error));
  }
  // Sends email allowing user to reset password
  resetPassword(email: string) {
    const fbAuth = firebase.auth();

    return fbAuth
      .sendPasswordResetEmail(email)
      .then(() => this.notify.update("Password update email sent", "info"))
      .catch((error) => this.handleError(error));
  }

  // If error, console log and notify user
  private handleError(error: Error) {
    console.error(error);
    //this.notify.update(error.message, "error");
  }

  isLoggedIn() {
    return this.afAuth.authState.pipe(first());
  }

  signOut() {
    this.afAuth.auth.signOut().then(() => {
      this.router.navigate(["/"]);
    });
  }

  canRead(user: Users): boolean {
    const allowed = ["admin"];
    return this.checkAuthorization(user, allowed);
  }

  async getUser() {
    return this.afAuth.authState.pipe(first()).toPromise();
  }

  private checkAuthorization(user: Users, allowedRoles: string[]): boolean {
    if (!user) return false;
    for (const role of allowedRoles) {
      if (user.roles[role]) {
        return true;
      }
    }
    return false;
  }
}
